import { Dayjs } from "dayjs";
import { number } from "yargs";

export type OrderStart = {
  termin_rozpoczecia: Dayjs | null;
  termin_zakonczenia: Dayjs | null;
  miasto: string;
  uslugi_zamowione: {
    cel_zamowienia: string;
    uslugi_dodatkowe: string[];
  };
};

export type Order = {
  //opis_uslugi: string;
  termin_rozpoczecia: Dayjs | null; //pole obowiązkowe
  termin_zakonczenia: Dayjs | null; //pole obowiązkowe
  kraj: string;
  wojewodztwo: string;
  kod_pocztowy: string;
  miasto: string;
  szerokosc_geograficzna: number;
  dlugosc_geograficzna: number;
  miejsce: StoragePlace;
  // skladowanie_plaskie: boolean;
  // wysokie_skladowanie: boolean;
  // polki: boolean;
  // warunek_temperaturowy: StorageTemperatureCondition;
  // rodzaj_towaru: StorageGoodsType;
  // opis_towaru: string | null;
  //specjalny_sprzet: string | null;
  // dodatkowe_uwagi: string | null;
  uslugi_zamowione: {
    cel_zamowienia: StorageMethod;
    uslugi_dodatkowe?: StorageMethod[];
  };
  // przedmioty_skladowania: StorageArticles[];

  // klient: {
  //   nazwa: string;
  //   nip: string;
  //   telefon: string;
  //   email: string;
  // };
  // id_klienta: string | null;
  // email_operatora: string | null;
};

export type StorageArticles = {
  rodzaj_opakowania: PackageType;
  dodatkowe_info: string | null;
  ilosc: number;
  waga: number;
  dlugosc: number;
  szerokosc: number;
  wysokosc: number;
  rozmiar: number;
  jednostka_wagi: WeightUnit;
  jednostka_dlugosci: DistanceUnit;
};

export enum StorageMethod {
  Skladowanie = 0,
  Crossdocking = 1,
  Fullfilment = 2,
  Etykietowanie = 3,
  Pakowanie = 4,
  Sortowanie = 5,
  ECommerce = 6,
  Wysylka = 7,
  Inne = 8,
}
export enum StoragePlace {
  Inside = 0,
  Outside = 1,
}
export enum StorageTemperatureCondition {
  Nieogrzewany = 0,
  Chlodnia = 1,
  Ogrzewanie = 2,
  TemperatureControl = 3,
}

export enum StorageGoodsType {
  Neutralny = 0,
  Medyczne = 1,
  Spozywcze = 2,
  DuzeADR = 3,
  Inne = 4,
}

export enum PackageType {
  // Carton = 0,
  // BigBag = 1,
  EURPallet = 2,
  HalfEurPallet = 3,
  // OtherPallet = 4,
  // Other = 5,
}

export enum WeightUnit {
  Kg = 0,
  Tona = 1,
  Dkg = 2,
}

export enum DistanceUnit {
  M = 0,
  Cm = 1,
  Mm = 2,
}